export default __webpack_public_path__ + "static/media/emptyorders.9bee92cc.png";